import { CommonFilterDescriptor } from "dto";

export class FilterData {
  public filterDescriptor: CommonFilterDescriptor;
  public filterOperator: number;
  public filterValue: any;
}
